<template>
  <section class="product-info-module">
    <div class="top-area">
      <h2>{{ data.title }}</h2>
      <p>{{ data.description }}</p>
    </div>
    <div class="info-area">
      <div class="left-side">
        <div v-for="(spec, index) of data.specs_categories" :key="index" class="info-category">
          <h3>{{ spec.spec_title }}</h3>
          <ProductInfoBar v-for="(category, indx) of spec.categories" :info="category" :key="`product-info-${indx}`" />
        </div>
      </div>
      <div class="right-side">
        <h3>Pre-Designed</h3>
        <ProductPreDesignedBar v-for="(pDesigned, ind) of data.pre_designed_categories" :key="ind" :info="pDesigned" />
      </div>
    </div>
  </section>
</template>
<script setup>
import ProductInfoBar from '@/components/modules/ProductInfoBar.vue'
import ProductPreDesignedBar from '@/components/modules/ProductPreDesignedBar.vue'
defineProps(['data'])
</script>
<style lang="scss" scoped>
.cursor-pointer {
              width: 50px;
              height: 50px;
            }
  .product-info-module {
    @apply main-container py-20;
    .top-area {
      @apply mb-20 lg:mb-32 ml-0 lg:ml-32;
      h2 {
      @apply text-ore_green_dark text-3xl font-light leading-[30px] mb-8 font-FHOscar;
      }
      p {
        @apply text-ore_green_dark text-[22px] lg:text-[40px] font-normal leading-tight lg:leading-10 font-FHOscar w-full lg:w-[43%];
      }
    }
    .info-area {
      @apply flex flex-col lg:flex-row gap-0 lg:gap-10;
      .left-side {
        @apply w-full lg:w-1/2;
        .info-category {
          @apply mb-32;
            h3 {
            @apply text-ore_green text-xl font-medium leading-10 mb-10 font-FHOscar relative;
            &::before {
              @apply absolute content-[''] w-[190px] h-0.5 bg-ore_green -top-3;
            }
          }
        }
      }
      .right-side {
        @apply w-full lg:w-1/2;
        h3 {
          @apply text-ore_green text-xl font-medium leading-10 mb-10 font-FHOscar relative;
          &::before {
            @apply absolute content-[''] w-[190px] h-0.5 bg-ore_green -top-3;
          }
        }
      }
    }
  }
</style>
